module.exports = __webpack_public_path__ + "4f8950907f4163dec736c875a129066c.jpg";